export default `
<section class="second ">
	<a href="++{{section21link}}" class="btn btn-lg pl-4 pr-4 pt-2 pb-2 mb-4 mt-2 button">++{{section21buttontext}}</a>
</section>
`